export default "__VITE_ASSET__0uA0r1zb__"